import { Reducer } from 'redux';
import { DenyListState, DenyListTypes } from './types';

const INITIAL_STATE: DenyListState = {
  denylistData: {
    id: '',
    status: 0,
    reason: '',
    message: '',
    createdAt: '',
    updatedAt: '',
    transportOperatorId: '',
    userId: '',
  },
  denylistList: [],
  error: false,
  loading: false,
};

const reducer: Reducer<DenyListState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST_DENYLIST
    case DenyListTypes.LIST_DENYLIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        denylistList: INITIAL_STATE.denylistList,
      };
    case DenyListTypes.LIST_DENYLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        denylistList: action.payload.denylistList,
      };
    case DenyListTypes.LIST_DENYLIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        denylistList: INITIAL_STATE.denylistList,
      };

    // CASES GET DENYLIST
    case DenyListTypes.GET_DENYLIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        denylistData: INITIAL_STATE.denylistData,
      };
    case DenyListTypes.GET_DENYLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        denylistData: action.payload.denylistData,
      };
    case DenyListTypes.GET_DENYLIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        denylistData: INITIAL_STATE.denylistData,
      };

    // CASES CREATE DENYLIST
    case DenyListTypes.CREATE_DENYLIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        denylistData: INITIAL_STATE.denylistData,
      };
    case DenyListTypes.CREATE_DENYLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        denylistData: action.payload.denylistData,
      };
    case DenyListTypes.CREATE_DENYLIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        denylistData: INITIAL_STATE.denylistData,
      };

    default:
      return state;
  }
};

export default reducer;
